import swiper from '../directives/media/swiper';

/**
 * Logo swiper controls.
 */
export default function cardsSection() {

  // Expander cards
  const expandMoreButtons = document.querySelectorAll('.button.-expand-more');
  if (expandMoreButtons) {
    expandMoreButtons.forEach(slmb => {
      slmb.addEventListener('click', event => {
        
        const section = slmb.closest(".body_section").querySelector(".body_cards.-expanding");
        if (section) {
          let cards = section.querySelectorAll('.card');
          cards.forEach(card => {
            card.classList.remove('-expand-hide');
          });
        }
        slmb.remove();
      });
    });
  }

  // general clicks
  document.querySelectorAll('div.card_content:not(.-no-link)').forEach(card => {
    let anchor = card.querySelector('a');
    if (anchor) card.addEventListener('click', event => {
      document.location.href = anchor.href;
    });
  });

  // Is there a logo swiper?
  const elements = document.querySelectorAll('.cards_swiper');
  if (elements.length < 1) return;

  elements.forEach(element => {
    swiper(element, swiper => {

      // Settings
      let settings = JSON.parse(element.dataset.cardsSwiper);
      if (!settings) return;
  
      // Init
      const slides = element.querySelectorAll('.swiper-slide');
      if (slides.length > 1) {
  
        const swiperInstance = new swiper(element, settings);

        // Bullets  
        const bullets = element.querySelectorAll('.hero_swiper_bullets.-in-page .bullet');
        const slideEnter = index => {
          bullets.forEach(bullet => {
            if (index == bullet.dataset.slide) {
              bullet.classList.remove('-exiting');
              bullet.classList.add('-active');
            }
          });
        }

        // Bullet animations
        slideEnter(0);
        swiperInstance.on('slideChangeTransitionEnd', () => slideEnter(swiperInstance.realIndex));
        swiperInstance.on('slideChangeTransitionStart', () => {
          bullets.forEach(bullet => {
            bullet.classList.replace('-active', '-exiting');
          });
        });

        // Bullet clicks
        bullets.forEach(bullet => {
          bullet.addEventListener('click', event => {
            swiperInstance.slideToLoop(parseInt(bullet.dataset.slide));
          });
        });
      }
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/cards.js